import React, { useCallback } from 'react'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import ActivityGroup from 'components/ActivityGroup'
import classes from './Bookmark.module.scss'
import Activities from 'routes/Board/Sidebar/Activities'
import { navigationController } from 'components/Modal'
import BoardDataProvider from 'dataProviders/Board'
import Loader from 'components/Loader'
import { CardLink } from 'components/Link'
import { Link } from 'react-router-dom'
import {
  LeftSidebarView,
} from 'components/Sidebar'

type Props = {
  id: number
  activityGroup: any
  currentUser: any
  onRemoveBookmark: (id: number) => void
}

const Bookmark: React.FC<Props> = ({
  id,
  activityGroup,
  currentUser,
  onRemoveBookmark,
}) => {
  const { push } = navigationController.useActions()

  const handleRemoveBookmarkClick = useCallback((event) => {
    event.stopPropagation()

    onRemoveBookmark(id)
  }, [id, onRemoveBookmark])

  const handleBoardActivityClick = useCallback(() => {
    push(({ transitionEnd }) =>
      <BoardDataProvider
        id={activityGroup.boardId}
      >
        {({ isReady }) =>
          isReady
            ? <Activities focusActivity={transitionEnd ? id : undefined} />
            : <LeftSidebarView><Loader center className='m-t-10 m-b-10' /></LeftSidebarView>
        }
      </BoardDataProvider>
    )
  }, [push, id, activityGroup])

  const wrap = useCallback(children => {
    if (activityGroup.cardId) {
      return (
        <CardLink
          cardId={activityGroup.cardId}
          state={{
            focusActivity: id
          }}
          className='clear-link-style'
        >
          {React.cloneElement(children, {
            onClick: () => {}
          })}
        </CardLink>
      )
    }

    return React.cloneElement(children, {
      onClick: handleBoardActivityClick
    })
  }, [id, activityGroup])

  const renderBoardName = useCallback(({ boardId, children, className }) =>
    <Link
      to={'/board/' + boardId}
      className={className}
      onClick={event => {
        event.preventDefault()

        handleBoardActivityClick()
      }}
    >
      {children}
    </Link>
  , [handleBoardActivityClick])

  const renderCardName = useCallback(({ cardId, children, className }) =>
    <CardLink
      cardId={cardId}
      state={{
        focusActivity: id
      }}
      className={className}
    >
      {children}
    </CardLink>
  , [id])

  return wrap(
    <ListItem
      className={classes.bookmark}
    >
      <div
        className={classes.bookmarkIcon}
        onClick={handleRemoveBookmarkClick}
      >
        <KanBoIcon fixedWidth name='kanbo-16-solid-bookmarked' />
      </div>
      <ActivityGroup
        {...activityGroup}
        context='notifications'
        currentUser={currentUser}
        boardNameComponent={renderBoardName}
        cardNameComponent={renderCardName}
      />
    </ListItem>
  )
}

export default Bookmark